import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { noop } from 'rxjs';
import {
  BaseBusinessKeyPipe,
  BaseInquiryShiftsWithFlexType,
  BaseModalService,
  EditInquiryFormInterface,
  InquiryCreateRequest,
  ShiftPlanCalendarDateInterface,
  ShiftTimeResponse,
  SimilarInquiryMappedInterface,
} from 'base';
import { ShiftPlanMdBubbleClickInterface } from '../../_interfaces/base-customer-shift-plan-md.interface';

@Component({
  selector: 'base-customer-shift-plan-md',
  templateUrl: './base-customer-shift-plan-md.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseCustomerShiftPlanMdComponent {
  @ViewChild('editTimeShifts', { static: true }) editTimeShifts: ElementRef;
  @ViewChild('shiftsUpdateModal', { static: true }) shiftsUpdateModal: ElementRef;

  @Input() editInquiryForm: FormGroup<EditInquiryFormInterface>;
  @Input() inquiryData: InquiryCreateRequest;
  @Input() inquiryId: number | undefined;
  @Input() isEmployeeShiftPlan: boolean;
  @Input() inquiredEmployeeName: string;
  @Input() canPublishInquiry: boolean;
  @Input() canSubmit: boolean;
  @Input() submitted: boolean;
  @Input() isSidebarVisible: boolean;
  @Input() similarInquiries: SimilarInquiryMappedInterface[] = [];

  @Output() save = new EventEmitter<void>();
  @Output() publish = new EventEmitter<void>();
  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() submittedChange = new EventEmitter<boolean>();

  timeShiftsModalRef: NgbModalRef;
  shiftDetailsModalRef: NgbModalRef;
  timeShifts: ShiftTimeResponse[] = [];
  selectedDay: ShiftPlanCalendarDateInterface;
  currentShift: BaseInquiryShiftsWithFlexType;

  constructor(private modalService: BaseModalService, private businessKeyPipe: BaseBusinessKeyPipe) {}

  bubbleClick({ shift, day }: ShiftPlanMdBubbleClickInterface): void {
    this.currentShift = shift;
    this.selectedDay = day;
    this.timeShifts = this.editInquiryForm.controls.timeShiftsForm.getRawValue();

    this.shiftDetailsModalRef = this.modalService.open(
      {
        headText: 'shiftModalTitle',
        bodyTemplate: this.shiftsUpdateModal,
        hideFooter: true,
      },
      {
        backdrop: 'static',
        size: 'lg',
      }
    );

    this.shiftDetailsModalRef.result.then(noop, noop);
  }

  openEditShiftTimesModal(): void {
    this.timeShiftsModalRef = this.modalService.open(
      {
        headText: this.businessKeyPipe.transform('action.editShiftTimes'),
        bodyTemplate: this.editTimeShifts,
        hideFooter: true,
      },
      {
        backdrop: 'static',
      }
    );

    this.timeShiftsModalRef.result.then(() => noop, noop);
  }
}
